import apiService from '@/services/apiService';

const actions = {
  getPaymentMethods({ commit }, payload) {
    console.log(payload);
    return new Promise((resolve, reject) => {
      apiService.post('payment-aggregator-payment-method/find-with-paging', payload)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPaymentMethodsList({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.post('payment-aggregator-payment-method/find-payment-gateway')
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getProductLocations({ commit }, formData) {
    return new Promise((resolve, reject) => {
      apiService.post('payment-aggregator-product-location/find-with-paging', formData)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPaymentMethod({ commit }, payload) {
    apiService.get(`payment-aggregator-payment-method/${payload}`)
      .then((response) => {
        commit('getPaymentMethod', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getPaymentMethodPopup({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`payment-aggregator-payment-method/${payload}/all-product-location`)
        .then((response) => {
          resolve(response.data.data);
          commit('getPaymentMethodPopup', response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  getPaymentMethodOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`payment-aggregator-payment-method/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error)
          console.log(error);
        });
    });
  },
  getProductLocationPopup({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`payment-aggregator-product-location/${payload}/all-payment-method-by-product-location`)
        .then((response) => {
          resolve(response.data.data);
          commit('getProductLocationPopup', response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getAllProductLocation({ commit }, payload) {
    apiService.post(`payment-aggregator-payment-method/find-all-product-location-used`, payload)
      .then((response) => {
        commit('getAllProductLocation', response.data.data);
      })
      .catch((error) => {
        reject(error);
        console.log(error);
      });
  },
  getAllType({ commit }) {
    apiService.post(`payment-aggregator-payment-method/find-all-type`)
      .then((response) => {
        commit('getAllType', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getAllGroupBy({ commit }) {
    apiService.post(`payment-aggregator-payment-method/find-all-group-by`)
      .then((response) => {
        commit('getAllGroupBy', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getProductLocation({ commit }, payload) {
    apiService.get(`payment-aggregator-product-location/${payload}`)
      .then((response) => {
        commit('getProductLocation', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  orderPaymentMethod({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`payment-method/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateAllIsEnable({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('payment-aggregator-payment-method/update-all-enable', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postPaymentMethod({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('payment-aggregator-payment-method', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postProductLocation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('payment-aggregator-product-location', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putPaymentMethod({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`payment-aggregator-payment-method/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putProductLocation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`payment-aggregator-product-location/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delPaymentMethod({ commit }, payload) {
    apiService.delete(`payment-method/${payload}`)
      .then((response) => {
        commit('delPaymentMethod', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
